<script lang="ts">
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import { loadPopes, calculateProgress, popesLoaded, popesError } from '$lib/stores/popeData';
  import { addUnit } from '$lib/utils/helpers';
  import type { ProgressData } from '$lib/types';
  import Loader from '$lib/components/Loader.svelte';
  import ProgressList from '$lib/components/ProgressList.svelte';
  import SignupForm from '$lib/components/SignupForm.svelte';
  import PopeDetails from '$lib/components/PopeDetails.svelte';
  
  export let year: string = '';
  export let month: string = '';
  
  let loading = true;
  let error = '';
  let progressData: ProgressData | null = null;
  
  $: birthYear = parseInt(year) || 0;
  $: birthMonth = parseInt(month) || 0;
  
  // Recalculate when popes are loaded and we have valid year/month
  $: {
    if ($popesLoaded && birthYear > 0 && birthMonth > 0) {
      progressData = calculateProgress(birthYear, birthMonth);
      if (!progressData) {
        error = 'Invalid date';
      } else {
        error = '';
      }
      loading = false;
    }
  }
  
  $: if ($popesError) {
    error = $popesError;
    loading = false;
  }
  
  onMount(async () => {
    await loadPopes();
  });
</script>

<svelte:head>
  <title>Your Progress - outlive.it</title>
</svelte:head>

<section id="intro" class="main">
  {#if loading}
    <Loader text="Loading your progress..." />
  {:else if error}
    <div class="error">
      <i class="bi-x-circle-fill"></i> {error}
    </div>
  {:else if progressData}
    <div id="area-signup">
      <h2>Your ranking: <b>{progressData.rank}/{progressData.maxRank}</b> (<b>{progressData.progress}%</b> complete)</h2>

      {#if progressData.showLastMonthNotification}
        <p>
          Last month you outlived <b>{progressData.lastMonthNotification}</b>.
        </p>
      {/if}

      <p>
        At <b>{progressData.age}</b> you have outlived <b>{addUnit(progressData.outlivedPopes, 'pope')}</b> and
        <b>{addUnit(progressData.outlivedAntipopes, 'antipope')}</b>.
        Still <b>{addUnit(progressData.popesToGo, 'pope')}</b> and <b>{addUnit(progressData.antipopesToGo, 'antipope')}</b> to go.
        <a href="/" on:click|preventDefault={() => navigate('/')}>Play again</a>.
      </p>

      <ProgressList 
        preceding={progressData.preceding}
        following={progressData.following}
        progress={progressData.progress}
        rank={progressData.rank}
      />

      <SignupForm birthYear={birthYear} birthMonth={birthMonth} />
    </div>
    
    <section id="popes-nearby">
      {#each progressData.previous as pope}
        <PopeDetails {pope} />
      {/each}
    </section>
  {/if}
</section>

<style>
  #intro {
    padding: 4em;
    background-color: #ffffff;
    border-radius: 4px;
    text-align: center;
  }

  .error {
    color: #ef6480;
  }

  #popes-nearby {
    margin-top: 1em;
  }

  @media screen and (max-width: 736px) {
    #intro {
      padding: 2em;
    }
  }

  @media screen and (max-width: 480px) {
    #intro {
      padding: 2em 1em;
    }
  }
</style>
